export default __webpack_public_path__ + "static/mobile-modal-a02f5faa52ddc9740b322f559c6780ee.png";